import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Header from "./components/header";
import Footer from "./components/footer";

const News = () => {
  const categories = ["All", "Press Releases", "Product Updates", "Company News", "Industry Insights"];
  const [selectedCategory, setSelectedCategory] = useState("All");

  const newsItems = [
    {
      id: 1,
      title: "iFLO Pro Featured in Comfort Zone AC Blog",
      date: "March 15, 2024", 
      category: "Industry Insights",
      image: "/news/comfortzone.png",
      summary: "Comfort Zone AC highlights how iFLO Pro's innovative technology prevents HVAC drain line clogs and water damage through continuous monitoring and treatment.",
      link: "https://www.comfortzoneacnow.com/heating/iflo-pro"
    },
    {
      id: 2,
      title: "iFLO Pro Featured in Today's A/C - January 2025",
      date: "January 1, 2025", 
      category: "Press Releases",
      image: "/news/todaysac.png",
      summary: "Today's A/C magazine features iFLO Pro's latest innovations and industry impact in their January 2025 issue.",
      link: "https://todays-ac.com/wp-content/uploads/2025/01/EntireJanuary2025Issue.pdf#page4"
    },
    {
      id: 3,
      title: "iFLO Pro Featured in Today's A/C - December 2024",
      date: "December 1, 2024",
      category: "Press Releases",
      image: "/news/todaysac.png",
      summary: "Today's A/C magazine features iFLO Pro in their December 2024 issue, discussing the latest developments in HVAC protection.",
      link: "https://todays-ac.com/wp-content/uploads/2024/12/EntireDecember2024Issue-1.pdf#page=4"
    },
    {
      id: 4,
      title: "iFLO Pro Featured in Today's A/C - November 2024",
      date: "November 1, 2024",
      category: "Press Releases",
      image: "/news/todaysac.png",
      summary: "Today's A/C magazine highlights iFLO Pro's innovative solutions in their November 2024 issue.",
      link: "https://todays-ac.com/wp-content/uploads/2024/10/Entire-November-2024-Issue.pdf#page=4"
    },
    {
      id: 5, 
      title: "iFLO Pro Featured in Today's A/C - October 2024",
      date: "October 1, 2024",
      category: "Press Releases",
      image: "/news/todaysac.png",
      summary: "Today's A/C magazine showcases iFLO Pro's technology in their October 2024 issue.",
      link: "https://todays-ac.com/wp-content/uploads/2024/10/Entire-October-2024-Issue.pdf#page=4"
    },
    {
      id: 6,
      title: "iFLO Pro Featured in Today's A/C - September 2024", 
      date: "September 1, 2024",
      category: "Press Releases",
      image: "/news/todaysac.png",
      summary: "Today's A/C magazine features iFLO Pro's solutions in their September 2024 issue.",
      link: "https://todays-ac.com/wp-content/uploads/2024/09/EntireSeptember2024Issue.pdf#page=4"
    },
    {
      id: 7,
      title: "iFLO Pro Featured in Today's A/C - August 2024",
      date: "August 1, 2024", 
      category: "Press Releases",
      image: "/news/todaysac.png",
      summary: "Today's A/C magazine highlights iFLO Pro's innovations in their August 2024 issue.",
      link: "https://todays-ac.com/wp-content/uploads/2024/08/EntireAugust2024Issue.pdf#page=4"
    },
    {
      id: 8,
      title: "iFLO Pro Featured in Today's A/C - July 2024",
      date: "July 1, 2024",
      category: "Press Releases", 
      image: "/news/todaysac.png",
      summary: "Today's A/C magazine features iFLO Pro's technology in their July 2024 issue.",
      link: "https://todays-ac.com/wp-content/uploads/2024/07/EntireJuly2024Issue.pdf"
    },
    {
      id: 9,
      title: "iFLO Pro Featured in Today's A/C - May 2024",
      date: "May 1, 2024",
      category: "Press Releases",
      image: "/news/todaysac.png",
      summary: "Today's A/C magazine showcases iFLO Pro's solutions in their May 2024 issue.",
      link: "https://todays-ac.com/wp-content/uploads/2024/05/EntireMay2024Issue.pdf#page=34"
    }
  ];

  const filteredNews = selectedCategory === "All" 
    ? newsItems 
    : newsItems.filter(item => item.category === selectedCategory);

  return (
    <div className="bg-white min-h-screen text-black">
      <Helmet>
        <title>iFLO Pro | Latest News</title>
        <meta name="description" content="Stay updated with the latest news and developments from iFLO Pro." />
        <meta name="keywords" content="iFLO Pro news, HVAC news, water damage prevention updates" />
      </Helmet>

      <Header />

      <main>
        <div className="relative h-[600px] mb-12">
          <img 
            src="/news/newsbg.png" 
            alt="News Header"
            className="w-full h-full object-cover brightness-50"
          />
          <div className="absolute inset-0 flex flex-col justify-end items-start p-12">
            <h1 className="text-4xl font-bold text-white mb-4">iFLO Pro in the Press</h1>
            <p className="text-gray-300 max-w-2xl">
                Stay updated on the latest news, revies, articles, and more
                featuring the greatest innovation in HVAC!
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 py-12">

        {/* Categories */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 rounded-full text-sm transition-colors duration-300 ${
                selectedCategory === category
                  ? "bg-yellow-500 text-black"
                  : "bg-gray-800 text-white hover:bg-gray-700"
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* News Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredNews.map((item) => (
            <div 
              key={item.id} 
              className="bg-gray-900 text-white rounded-lg overflow-hidden hover:transform hover:scale-105 transition-transform duration-300"
            >
              <div className="aspect-w-16 aspect-h-9">
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="w-full h-48 object-cover"
                />
              </div>
              <div className="p-6">
                <div className="flex justify-between items-center mb-3">
                  <span className="text-yellow-500 text-sm">{item.date}</span>
                  <span className="text-sm text-gray-400">{item.category}</span>
                </div>
                <h2 className="text-xl font-bold mb-3">{item.title}</h2>
                <p className="text-gray-400 mb-4">{item.summary}</p>
                <a 
                  href={item.link} 
                  className="inline-block bg-yellow-500 text-black px-4 py-2 rounded hover:bg-yellow-600 transition-colors duration-300"
                >
                  Read More
                </a>
              </div>
            </div>
          ))}
        </div>

        <h1 className="text-4xl font-bold text-center mb-8 mt-12">Events</h1>

        <div class="elfsight-app-9185b78c-c039-4bbe-be6d-bf929e58b5cc" data-elfsight-app-lazy></div>

        </div>
      </main>

      <Footer />
    </div>
  );
};

export default News;
